import 'mdn-polyfills/Array.prototype.includes';

import { FallcoClass }          from '../../../classes/FallcoClass';
import Utilities, { Sanitizer } from '../../utilities/src/utilities';
import Console                  from '../../fallco_console';

/**
 * Classe che controlla e gestisce i cambiamenti che avvengono dentro un form.
 * Se quindi ci sono cambiamenti fatti, prima di cambiare pagina, avvisa l'utente che se continuerà
 * perderà i dati non salvati.
 *
 * Per usare questa classe basta chiamare la funzione "window.form_helper.track_changes()" e passare come parametro
 * una stringa che contenga i selettori jQuery che identificano i form che si desiderano controllare.
 *
 * Per evitare che un input venga incluso nel tracking, aggiungerci l'attributo "fh_track='false'".
 *
 * @constructor
 */
class FormHelper extends FallcoClass {
  constructor () {
    super();
    
    this._forms                     = [];
    this._auto_init                 = true;
    this._auto_remove_old_listeners = true;
    
    /**
     *
     * @param {Event} e
     * @private
     */
    this._on_dom_content_loaded = (e) => {
      if (!this._auto_init) {
        return;
      }
      
      this._on_load(e);
    };
    
    document.addEventListener('DOMContentLoaded', this._on_dom_content_loaded);
    window.addEventListener('load', e => {
      if(!document.querySelector('body[class^=fallcoaste]')) {
      if (!this._auto_remove_old_listeners) {
        return;
      }
      this._remove_old_before_unload_listeners(e);
      }
    });
    
    document.addEventListener('ajax_success.fw.ajax', e => this._on_ajax_copmplete(e));
    document.addEventListener('ajax_error.fw.ajax', e => this._on_ajax_copmplete(e));
    
    if (!document.on_paste_listener) {
      document.on_paste_listener = true;
      document.addEventListener('paste', this._on_paste);
    }
    
    return super.expose_to_public('form_helper', this);
  }
  
  get auto_init () {
    return this._auto_init;
  }
  
  set auto_init (val) {
    this._auto_init = val;
  }
  
  set auto_remove_old_listeners (val) {
    this._auto_remove_old_listeners = val;
  }
  
  _remove_old_before_unload_listeners () {
    // Rimuove qualsiasi altro evento che ci potrebbe essere sul "beforeload" create d altre librerie, ed aggiunge il suo.
    window.onbeforeunload = undefined;
    
    $(window).off('beforeunload')
      .unbind('beforeunload');
    
    if (this._temp) {
      window.removeEventListener('beforeunload', this._temp);
    }
    
    this._temp = (e) => {
      this._on_beforeunload(e);
    };
    
    window.addEventListener('beforeunload', this._temp);
  }
  
  /**
   * evento al load della pagina. Inizializza la libreria.
   * @private
   */
  _on_load () {
    let forms_to_skip = ['[fw-track-changes=\'false\']', '[fw-filters-form]'];
    
    // Hack per bypassare il controllo di "functions.js" che imposta la variabile "submit_cliccato" a true.
    // Quando questo è a true, mostra un avviso "Attendere il salvataggio dei dati".
    // Con questo hack, la variabile "submit_cliccato" rimane sempre a FALSE per evitare il messaggio.
    $('form [type=\'submit\']').click(function () {
      window.submit_cliccato = false;
    });
    
    // Nel selector, esclude i form con attributo "fw-track-changes='false'" ed i form dei filtri con attributo "fw-filters-form"
    this.track_changes('form:not(' + forms_to_skip.join('):not(') + ')');

    let passwordElements = document.querySelectorAll('input[type=password]');
    let that = this;
    Object.keys(passwordElements).forEach(function(pswEl) {
      that._generateEye(passwordElements[pswEl].type === 'text', passwordElements[pswEl], that);
    })
  }

  _destroyEye(e) {
    e.currentTarget.remove();
  }

  _generateEye(is_open = false, passwordElement, that) {
    let eyeText = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d=\"M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z\"/></svg>"
    let eyePsw = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d=\"M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM223.1 149.5L313.4 220.3C317.6 211.8 320 202.2 320 191.1C320 180.5 316.1 169.7 311.6 160.4C314.4 160.1 317.2 159.1 320 159.1C373 159.1 416 202.1 416 255.1C416 269.7 413.1 282.7 407.1 294.5L446.6 324.7C457.7 304.3 464 280.9 464 255.1C464 176.5 399.5 111.1 320 111.1C282.7 111.1 248.6 126.2 223.1 149.5zM320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L177.4 235.8C176.5 242.4 176 249.1 176 255.1C176 335.5 240.5 400 320 400C338.7 400 356.6 396.4 373 389.9L446.2 447.5C409.9 467.1 367.8 480 320 480H320z\"/></svg>"
    let eyeElement = document.createElement('span');
    eyeElement.style.width = "20px";
    eyeElement.style.height = "20px";
    eyeElement.style.position = "absolute";
    eyeElement.style.right = "15px";
    eyeElement.style.top = "8px";
    eyeElement.style.display = "inline-block";
    eyeElement.innerHTML = is_open ? eyePsw : eyeText

    eyeElement.addEventListener('click', function(e) {
      passwordElement.type = passwordElement.type === 'text' ? 'password' : 'text'
      that._destroyEye(e);
      that._generateEye(passwordElement.type === 'text', passwordElement, that)
    })

    if(passwordElement.closest("div")) {
      passwordElement.closest("div").appendChild(eyeElement)
    }
  }
  
  /**
   * Quando avviene il paste, sanitizza il testo da incollare
   *
   * @param {ClipboardEvent} e
   * @private
   */
  _on_paste (e) {
    if(e.target.hasAttribute('readonly')) {
      return;
    }
    if (!e.clipboardData && !window.clipboardData) {
      return;
    }

    let allowed_types   = ['text', 'textarea'];
    let target_type     = Utilities.get_control_type(e.target);
    let string_to_paste = (e.clipboardData || window.clipboardData).getData('text');
    
    if (allowed_types.includes(target_type) && string_to_paste) {
      e.preventDefault();
      
      let sanitized_string       = Sanitizer.pasted_string(string_to_paste);
      let selection              = {
        start: e.target.selectionStart,
        end:   e.target.selectionEnd
      };
      let new_selection_position = selection.end + sanitized_string.length;
      
      e.target.value          = Utilities.replace_range(selection.start, selection.end, e.target.value, sanitized_string);
      e.target.selectionStart = new_selection_position;
      e.target.selectionEnd   = new_selection_position;
      
      e.target.dispatchEvent(new CustomEvent('input', {
        bubbles:    e.bubbles,
        cancelable: e.cancelable
      }));
      e.target.dispatchEvent(new CustomEvent('change', {
        bubbles:    e.bubbles,
        cancelable: e.cancelable
      }));
    }
  }
  
  /**
   * Si assicura che non ci siano elementi con lo stato :focus.
   * @private
   */
  _unfocus_inputs () {
    if (this._forms instanceof Array) {
      return;
    }
    this._forms.find(':focus').blur();
  }
  
  /**
   * Evento prima che la pagina venga ricaricata.
   * Se ci sono modifiche in sospeso mostra un avviso all'utente che lo informa che i dati andranno persi se non vengono salvati.
   *
   * @param {BeforeUnloadEvent} ev
   * @private
   */
  _on_beforeunload (ev) {
    this._unfocus_inputs();
    
    if (this.are_changed_forms()) {
      ev.preventDefault();
      ev.returnValue = '';
    }
  }
  
  _on_ajax_copmplete (e) {
    let form = document.querySelector('form[submitting=\'true\']');
    
    if (!form) {
      return;
    }
    
    form.submitting = false;
    form.removeAttribute('submitting');
    
    if (e.type === 'ajax_success.fw.ajax') {
      form.elements_changed = [];
    }
  }
  
  /**
   * Funzione che avvia il tracking dei cambiamenti degli input di un form.
   * Per evitare che un input non venga incluso nel tracking, aggiungergli l'attributo "fh_track='false'".
   *
   * @param {string} forms_selector
   * @event form_helper.track_changes_completed
   * @property {Object} data
   */
  track_changes (forms_selector) {
    if(!document.querySelector('body[class^=fallcoaste]')) {
    this._remove_old_before_unload_listeners();
    }

    this._forms = $(forms_selector);
    this._forms.attr('fw-track-changes', true);
    
    this._forms.find('select>option:not([value]), select>option[value=\'\']').attr('value', '').map(function (i, option) {
      let select = option.parentNode;
      if (select.value === '') {
        select.options[0].defaultSelected = true;
        option.defaultSelected            = true;
      }
    });
    
    /**
     * Si deve usare l'evento change di jQuery sull'intero form in quanto questo ascolta anche i Buble dei change dei suoi childs.
     */
    this._forms
      .on('change dp.change', function (e) {
        let selectors        = ['input', 'select', 'textarea'];
        let input            = (selectors.indexOf(e.target.localName.toLowerCase()) === -1) ? e.target.querySelector(selectors.join(',')) : e.target;
        let $input           = $(input);
        let name             = input.name;
        let form             = this;
        let changed          = false;
        let must_skip        = false;
        // elenco degli elementi che non devono essere controllati per eventuali modifiche.
        let elements_to_skip = [
          { name: 'jump_record' },
          {
            attr:  'modificato',
            value: 'no'
          },
          {
            attr:  'fh_track',
            value: 'false'
          }
        ];
        
        elements_to_skip.map(function (obj) {
          if (obj.name && $input.attr('name') === obj.name) {
            must_skip = true;
          } else if (obj.attr && $input.attr(obj.attr) === obj.value) {
            must_skip = true;
          }
        });
        
        if (must_skip) {
          return;
        }
        
        // Instanzia la proprietà "elementsChanged" che conterrà i nomi dei campi cambiati.
        if (!form.elements_changed) {
          form.elements_changed = [];
        }
        
        if (!form.forced_changed) {
          form.forced_changed = false;
        }
        
        if (name === '') {
          name = 'unnamed_' + (input.nodeName.toLowerCase() === 'input' ? input.type + '_input' : input.nodeName.toLowerCase());
        }
        
        switch (input.nodeName.toLowerCase()) {
        case 'input':
          switch (input.type) {
          case 'radio':
          case 'checkbox':
            changed = input.defaultChecked !== input.checked;
            break;
          case 'file':
            // Al momento non controlla se ci sono allegati aggiunti o meno.
            // Forse fare una funziona da chiamare manualmente per impostare un elemento come modificato.
            break;
          default:
            changed = input.defaultValue !== input.value;
          }
          break;
        case 'select':
          /**
           * @type {HTMLCollection}
           */
          for (let x = 0; x < input.children.length; x++) {
            if (input.children.item(x).defaultSelected !== input.children.item(x).selected) {
              changed = true;
            }
          }
          break;
        case 'textarea':
          changed = input.defaultValue !== input.value;
          break;
        }
        
        if (changed) {
          Console.log('Form Change - Campo: ', input.name, ' - DefaultValue: ', input.defaultValue, ' - NewValue: ', input.value);
        }
        
        if (changed && form.elements_changed.indexOf(name) === -1) {
          form.elements_changed.push(name);
        } else if (!changed && form.elements_changed.indexOf(name) > -1) {
          form.elements_changed.splice(form.elements_changed.indexOf(name), 1);
        }
        
        /**
         * Effettua il dispatch di un evento custom dopo che il controllo del form è stato completato.
         */
        $(form).trigger('form_helper.track_changes_completed', { form_changed: form.elements_changed.length > 0 });
      })
      .on('submit', function (e) {
        /**
         * In caso di submit cliccato, se ci ri-clicco una seconda volta non fa nulla in quanto risulta gia in fase di submitting.
         * Questo è utile nei casi di submit con reload della pagina.
         */
        if (this.submitting === true) {
          return e.preventDefault();
        }
        
        this.submitting = true;
        this.setAttribute('submitting', true);
      })
      .on('reset', function () {
        let form = this;
        
        if (form.elements_changed) {
          form.elements_changed = [];
        }
      });
  }
  
  /**
   * Ritorna un array di form che hanno dato non salvati.
   * Se si passa un parametro Booleano, ritorna solo il numero dei form con cambiamenti non salvati.
   *
   * @param {Boolean} length
   * @return {Array | Number}
   */
  get_changed_forms (length) {
    let changed_forms = [];
    
    this._forms.map(function (i, form) {
      if (form.submitting) {
        return false;
      }
      
      if ((form.elements_changed && form.elements_changed.length > 0) || form.forced_changed) {
        changed_forms.push(form);
      }
    });
    
    if (length) {
      return changed_forms.length;
    }
    
    return changed_forms;
  }
  
  /**
   * Resetta la proprietà "elements_changed" del form passato come target.
   * Se non viene passato alcun target, prende tutti i form che in quel momento sono modificati.
   *
   * La proprietà "elements_changed" viene usata per controllare i form con cambiamenti non salvati e
   * all'evento beforeunload mostra l'alert che informa l'utente che ci son cambiamenti non salvati.
   *
   * @param {jQuery | HTMLElement} [target]
   */
  reset_form_changes (target) {
    let targets_array = [];
    
    if (!target) {
      target = this.get_changed_forms();
    }
    
    if (target instanceof Array) {
      targets_array = target;
    } else if (target instanceof jQuery) {
      if (target.length > 1) {
        target.map(function (i, form) {
          targets_array.push(form);
        });
      } else {
        targets_array.push(target[0]);
      }
    } else {
      targets_array.push(target);
    }
    
    targets_array.map(function (form) {
      form.elements_changed = [];
    });
  }
  
  /**
   * Ritorna un booleano che indica se ci sono form con cambiamenti non salvati.
   *
   * @return {boolean}
   */
  are_changed_forms () {
    return this.get_changed_forms(true) > 0;
  }
  
  /**
   * Ritorna un booleano che indica se ci sono cambiamenti non salvati nel form.
   *
   * @param {HTMLElement} form
   * @param {Array} form.elements_changed
   * @return {boolean}
   */
  is_changed (form) {
    return form.elements_changed && form.elements_changed.length > 0;
  }
  
  /**
   * Setta (o meno) forzatamente il form come cambiato
   *
   * @param {HTMLElement|jQuery} form
   * @param {boolean} state
   */
  set_forced_changed (form, state = true) {
    let form_target = typeof jQuery !== 'undefined' && form instanceof jQuery ? form[0] : form;
    
    form_target.forced_changed = state;
  }
}

export default new FormHelper();
